module.exports = __webpack_public_path__ + "static/media/icon-refresh.501f84c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-refresh.svg
// module id = ./src/assets/images/icon-refresh.svg
// module chunks = 6